export default __webpack_public_path__ + "static/media/2021 Twitter logo - white.png";